export default __webpack_public_path__ + "static/Sketch-button-architecture-edaacc502fc16a00ee107bed99321639.png";